import { render, staticRenderFns } from "./team-history.vue?vue&type=template&id=09e4ce57&"
import script from "./team-history.vue?vue&type=script&lang=js&"
export * from "./team-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports